import * as Sentry from '@sentry/react';
import { isErrorTrackingAllowed } from './app/lib/cookie-consent';

const dsn = import.meta.env.VITE_SENTRY_DSN;

export function initSentryIfAllowed(): void {
  if (!dsn) return;
  if (!isErrorTrackingAllowed()) return;
  if (Sentry.isInitialized()) return;

  Sentry.init({
    dsn,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Initialize on load if consent was already given
initSentryIfAllowed();
